/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Notifications_Scope_ItemInputs */

const he_account_notifications_scope_item = /** @type {(inputs: Account_Notifications_Scope_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוצר`)
};

const en_account_notifications_scope_item = /** @type {(inputs: Account_Notifications_Scope_ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

/**
* | output |
* | --- |
* | "Item" |
*
* @param {Account_Notifications_Scope_ItemInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_scope_item = /** @type {((inputs?: Account_Notifications_Scope_ItemInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Scope_ItemInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_scope_item(inputs)
	return en_account_notifications_scope_item(inputs)
});